import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Segment } from 'semantic-ui-react';
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Seoul');

const propTypes = {
  loading: PropTypes.bool.isRequired,
  onMovePage: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
const defaultProps = {};

const HolidayBottom = ({ onMovePage, onSave, loading }) => {
  return (
    <Grid className="form-btn">
      <Grid.Column width={4}></Grid.Column>
      <Grid.Column width={12} textAlign="right">
        <Button className="cancel" inverted color="grey" onClick={onMovePage}>
          취소
        </Button>
        <Button className="ok" color="green" disabled={loading} onClick={onSave}>
          저장
        </Button>
      </Grid.Column>
      <Segment vertical />
    </Grid>
  );
};

HolidayBottom.propTypes = propTypes;
HolidayBottom.defaultProps = defaultProps;

export default HolidayBottom;
